import { makeStyles, shorthands, tokens } from "@fluentui/react-components";

export const useM365PulseFlyoutStyles = makeStyles({
    root: {
        display: "flex",
        flexDirection: "column",
        height: "100%",
        overflowY: "auto"
    },
    body: {},
    flyoutFooter: {
        display: "flex",
        marginTop: "auto",
        bottom: 0,
        ...shorthands.padding(tokens.spacingHorizontalL, "0px"),
        marginBottom: "45px",
        width: "100%",
        ...shorthands.gap(tokens.spacingVerticalM)
    }
});
